import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=a1e491ce&"
import script from "./CommentCard.vue?vue&type=script&lang=ts&"
export * from "./CommentCard.vue?vue&type=script&lang=ts&"
import style0 from "./CommentCard.vue?vue&type=style&index=0&id=a1e491ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports